import { useEffect } from "react";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import { applySeo } from "@/lib/seo";

export default function Risikohinweis() {
  useEffect(() => {
    applySeo({
      title: "Risikohinweis & Haftungsausschluss – Grüne Geldanlage",
      description: "Risikohinweis und Haftungsausschluss für nachhaltige Geldanlagen: keine Anlageberatung, keine Gewähr für Kursentwicklungen, eigenverantwortliche Anlageentscheidung.",
      canonicalPath: "/risikohinweis",
    });
  }, []);
  return (
    <div className="min-h-screen bg-brand-paper" data-testid="risiko-page">
      <Header />
      <section className="max-w-3xl mx-auto px-6 lg:px-10 pt-20 pb-24">
        <div className="overline mb-4">Rechtliches</div>
        <h1 className="font-serif text-5xl font-light leading-tight text-brand-dark mb-10">Risikohinweis &amp; Haftungsausschluss</h1>
        <div className="prose-editorial max-w-none">
          <h2>Keine Anlageberatung</h2>
          <p>Die auf Grüne Geldanlage veröffentlichten Inhalte stellen weder eine Anlageberatung noch eine Kauf- oder Verkaufsempfehlung dar. Sie ersetzen keine individuelle Beratung durch einen qualifizierten und regulierten Finanz- oder Anlageberater.</p>

          <h2>Keine Gewähr für Kursentwicklungen</h2>
          <p>Historische Renditen, Vergleichsdaten und Berechnungsergebnisse (z. B. aus unseren interaktiven Rechnern) sind Modellrechnungen bzw. Vergangenheitswerte. Sie erlauben keine verlässliche Prognose zukünftiger Wertentwicklungen. Kapitalmarktanlagen unterliegen Kurs-, Währungs- und Emittentenrisiken – bis hin zum Totalverlust des eingesetzten Kapitals.</p>

          <h2>Eigenverantwortliche Anlageentscheidung</h2>
          <p>Jede Anlageentscheidung treffen Sie eigenverantwortlich. Prüfen Sie vor einer Anlage die vollständigen Verkaufsunterlagen des jeweiligen Produkts (Verkaufsprospekt, wesentliche Anlegerinformationen/PRIIPs-KID, Jahres-/Halbjahresberichte) und ziehen Sie – wo notwendig – professionelle Hilfe hinzu.</p>

          <h2>Haftungsausschluss</h2>
          <p>Trotz größter Sorgfalt bei der Erstellung der Inhalte übernehmen wir keine Gewähr für Aktualität, Richtigkeit und Vollständigkeit. Haftungsansprüche gegen die Redaktion, die sich auf Schäden materieller oder ideeller Art beziehen und durch die Nutzung oder Nichtnutzung der dargebotenen Informationen verursacht wurden, sind grundsätzlich ausgeschlossen, sofern kein nachweislich vorsätzliches oder grob fahrlässiges Verschulden vorliegt.</p>

          <blockquote>Nachhaltigkeit ist ein zusätzliches Kriterium – kein Ersatz für finanzielle Risikoprüfung.</blockquote>
        </div>
      </section>
      <Footer />
    </div>
  );
}
